/* NESCENTCITY theme JS — drawers, cart, carousels, bundles */
(function () {
  'use strict';

  /* ---------- drawers ---------- */
  function openDrawer(name) {
    var d = document.getElementById('drawer-' + name);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    /* Show ONLY the scrim that belongs to this drawer. Showing both put the
       cart scrim on top of the menu drawer (header z-index stacking context),
       which swallowed every click on the menu links. */
    var scrim = name === 'menu' ? document.querySelector('.hdr__scrim') : document.querySelector('.cd__scrim');
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    document.querySelectorAll('.cd.is-open,.hdr__drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.cd__scrim,.hdr__scrim').forEach(function (s) { s.hidden = true; });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- money ---------- */
  function money(cents) {
    var f = (window.NSC && window.NSC.moneyFormat) || '${{amount}}';
    var a = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, a);
  }

  /* ---------- cart fetch ---------- */
  function refreshCart() {
    fetch((window.NSC.cartUrl || '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }
  window.NSCRefreshCart = refreshCart;

  function cartChanged() {
    document.dispatchEvent(new CustomEvent('nsc:cart-changed'));
  }

  /* ---------- quantity tiers on PDP ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-tiers] input');
    if (!input) return;
    document.querySelectorAll('.pdp__tier').forEach(function (t) { t.classList.remove('is-active'); });
    input.closest('.pdp__tier').classList.add('is-active');
  });

  /* ---------- pdp gallery thumbs ---------- */
  (function () {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return;
    var slides = gal.children;
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        if (!slides[i]) return;
        gal.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
      });
    });
  })();

  /* ---------- quantity stepper (PDP) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    e.preventDefault();
    var input = b.parentNode.querySelector('[data-qty-input]');
    if (!input) return;
    var n = parseInt(input.value, 10) || 1;
    n = b.getAttribute('data-qty') === '+' ? n + 1 : Math.max(1, n - 1);
    input.value = n;
  });

  /* ---------- add to cart (PDP, AJAX → drawer) ---------- */
  var form = document.getElementById('pdp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      var label = form.querySelector('[data-atc-label]');
      var id = form.querySelector('[data-variant-id]').value;
      var qInput = form.querySelector('[data-qty-input]');
      var qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
      var planEl = form.querySelector('[data-plan-radio]:checked');
      var plan = planEl && planEl.value ? planEl.value : null;
      btn.disabled = true;
      label.textContent = 'Adding…';
      var payload = { id: parseInt(id, 10), quantity: qty };
      if (plan) payload.selling_plan = parseInt(plan, 10);
      fetch(window.NSC.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          label.textContent = 'Added ✓';
          refreshCart();
          cartChanged();
          openDrawer('cart');
          setTimeout(function () {
            label.textContent = 'Add to cart';
            btn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          label.textContent = 'Try again';
          btn.disabled = false;
        });
    });
  }

  /* ---------- card add to cart (site-wide, product cards) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-catc]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var label = btn.querySelector('[data-catc-label]') || btn;
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding…';
    fetch((window.NSC && window.NSC.cartAddUrl) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-vid'), 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.add('is-added');
        label.textContent = 'Added ✓';
        refreshCart();
        cartChanged();
        openDrawer('cart');
        setTimeout(function () {
          btn.classList.remove('is-added');
          label.textContent = original;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        label.textContent = 'Try again';
        btn.disabled = false;
      });
  });

  /* Cart line quantity handling lives in cart-drawer.js (AJAX re-render). */

  /* ---------- category showcase carousels ---------- */
  document.querySelectorAll('[data-showcase]').forEach(function (sec) {
    var track = sec.querySelector('[data-track]');
    var items = track ? track.children : [];
    var dots = sec.querySelector('[data-dots]');
    if (!track || !items.length) return;

    if (dots && !dots.children.length) {
      for (var i = 0; i < items.length; i++) {
        var d = document.createElement('span');
        d.className = 'cs__dot' + (i === 0 ? ' is-on' : '');
        dots.appendChild(d);
      }
    }

    function offsetOf(i) {
      return items[i].offsetLeft - items[0].offsetLeft;
    }
    function index() {
      var x = track.scrollLeft;
      var best = 0;
      var bestD = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(offsetOf(i) - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }
    function go(n, instant) {
      var t = Math.min(items.length - 1, Math.max(0, n));
      var left = offsetOf(t);
      if (track.scrollTo) {
        track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }
    }

    var prev = sec.querySelector('[data-prev]');
    var next = sec.querySelector('[data-next]');

    var autoMs = parseInt(sec.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canAuto = autoMs > 0 && !reduce && items.length > 1;
    var timer = null;
    var held = false;
    var onScreen = true;
    var resumeTimer = null;

    function tick() {
      if (held || !onScreen || document.hidden) return;
      var n = index();
      if (n >= items.length - 1) {
        go(0, true);
      } else {
        go(n + 1);
      }
    }
    function startAuto() {
      if (!canAuto || timer) return;
      timer = setInterval(tick, autoMs);
    }
    function hold() {
      held = true;
      clearTimeout(resumeTimer);
    }
    function release(delay) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { held = false; }, delay || 0);
    }
    function nudge() {
      hold();
      release(Math.max(autoMs * 2, 5000));
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); nudge(); go(index() - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); nudge(); go(index() + 1); });

    if (canAuto) {
      sec.addEventListener('mouseenter', hold);
      sec.addEventListener('mouseleave', function () { release(0); });
      sec.addEventListener('focusin', hold);
      sec.addEventListener('focusout', function () { release(0); });
      track.addEventListener('pointerdown', nudge);
      track.addEventListener('touchstart', nudge, { passive: true });
      track.addEventListener('wheel', nudge, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
        }, { threshold: 0.2 }).observe(sec);
      }

      startAuto();
    }

    var ticking;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var n = index();
        if (dots) {
          for (var i = 0; i < dots.children.length; i++) {
            dots.children[i].classList.toggle('is-on', i === n);
          }
        }
        ticking = false;
      });
    });
  });

  /* ---------- move bundle under add-to-cart ---------- */
  (function () {
    var slot = document.querySelector('[data-bundle-slot]');
    var bb = document.querySelector('[data-bundle][data-position="atc"]');
    if (slot && bb) slot.appendChild(bb);
  })();

  /* ---------- bundle builder ---------- */
  document.querySelectorAll('[data-bundle]').forEach(function (bb) {
    var total = parseInt(bb.getAttribute('data-slots'), 10) || 5;
    var picker = bb.querySelector('[data-picker]');
    var fill = bb.querySelector('[data-bb-fill]');
    var addBtn = bb.querySelector('[data-bb-add]');
    var addLabel = bb.querySelector('[data-bb-add-label]');
    var baseLabel = addLabel ? addLabel.textContent : 'Add bundle';
    var picks = {};
    var activeSlot = null;

    function chosenCount() {
      return Object.keys(picks).length;
    }

    function paint() {
      var n = chosenCount();
      if (fill) fill.style.width = Math.round((n / total) * 100) + '%';
      if (addBtn) {
        addBtn.disabled = n < total;
        if (addLabel) {
          addLabel.textContent = n < total ? baseLabel + ' (' + n + '/' + total + ')' : baseLabel;
        }
      }
    }

    function openPicker(slot) {
      activeSlot = slot;
      if (picker) picker.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closePicker() {
      if (picker) picker.hidden = true;
      document.body.style.overflow = '';
      activeSlot = null;
    }

    bb.addEventListener('click', function (e) {
      var choose = e.target.closest('[data-choose]');
      if (choose) {
        e.preventDefault();
        openPicker(choose.getAttribute('data-choose'));
        return;
      }
      if (e.target.closest('[data-picker-close]') || e.target === picker) {
        e.preventDefault();
        closePicker();
        return;
      }
      var opt = e.target.closest('[data-pick]');
      if (opt && activeSlot) {
        e.preventDefault();
        var slotEl = bb.querySelector('[data-slot="' + activeSlot + '"]');
        var btn = slotEl.querySelector('[data-choose]');
        picks[activeSlot] = opt.getAttribute('data-vid');
        slotEl.classList.add('is-filled');
        var img = opt.getAttribute('data-img');
        var color = opt.getAttribute('data-color');
        var thumb = img
          ? '<img class="bb__pick-img" src="' + img + '" alt="">'
          : '<span class="bb__pick-img" style="background:' + color + '"></span>';
        btn.innerHTML =
          '<span class="bb__pick">' + thumb +
          '<span class="bb__pick-txt">' +
          '<span class="bb__pick-name">' + opt.getAttribute('data-title') + '</span>' +
          '<span class="bb__pick-price">' + (opt.getAttribute('data-price') || '') + '</span>' +
          '</span></span><span class="bb__swap">Change</span>';
        closePicker();
        paint();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && picker && !picker.hidden) closePicker();
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (chosenCount() < total) return;
        var items = Object.keys(picks).map(function (k) {
          return { id: parseInt(picks[k], 10), quantity: 1 };
        });
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Adding…';
        fetch(window.NSC.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            if (addLabel) addLabel.textContent = 'Added ✓';
            refreshCart();
            cartChanged();
            openDrawer('cart');
            setTimeout(function () {
              if (addLabel) addLabel.textContent = baseLabel;
              addBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            if (addLabel) addLabel.textContent = 'Try again';
            addBtn.disabled = false;
          });
      });
    }

    paint();
  });

  refreshCart();
})();
